import React, { useEffect, useState } from 'react';
import { getShopOrders } from '../services/api';
import { Card, Row, Col, Alert } from 'react-bootstrap';
import './ShopOrdersCard.css';

function ShopOrders() {
  const [orders, setOrders] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const res = await getShopOrders();
      setOrders(res.data);
    } catch (e) {
      setError('获取订单失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <h2>我的兑换订单</h2>
      {error && <Alert variant="danger">{error}</Alert>}
      {orders.length === 0 && !loading && (
        <div style={{background:'#ccf5ff', borderRadius:8, padding:'16px 0', textAlign:'center', marginTop:12, marginBottom:20, color:'#38b6c1', fontSize:'1.05em'}}>
          暂无兑换订单
        </div>
      )}
      <Row xs={1} md={2} lg={3} className="g-4 mt-2">
        {orders.map(order => (
          <Col key={order.id}>
            <Card className={order.status === 'refunded' ? 'order-refunded' : ''}>
  <div className="shop-card-img">
  <img src={order.product_image || 'https://via.placeholder.com/300x200?text=No+Image'} alt={order.product_name} />
</div>
  <Card.Body>
                <div className="shop-card-title" title={order.product_name}>{order.product_name}</div>
                <Card.Text className="bg-light rounded-3 p-2">
                  <b>兑换数量：</b>{order.quantity}<br/>
                  <b>总积分：</b>{order.points_required * order.quantity}<br/>
                  <b>单价：</b>{order.points_required}<br/>
                  <b>兑换时间：</b>{order.created_at ? order.created_at.split('.')[0].replace('T', ' ') : ''}<br/>
                  <b>订单状态：</b>{
                    order.status === 'pending' ? '待发货' :
                    order.status === 'shipped' ? '已发货' :
                    order.status === 'completed' ? '已完成' :
                    order.status === 'refunded' ? '已退单' : order.status
                  }
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}

export default ShopOrders;
